import { render, staticRenderFns } from "./UploadBulkResume..vue?vue&type=template&id=2df934bb&scoped=true"
import script from "./UploadBulkResume..vue?vue&type=script&lang=ts"
export * from "./UploadBulkResume..vue?vue&type=script&lang=ts"
import style0 from "./UploadBulkResume..vue?vue&type=style&index=0&id=2df934bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df934bb",
  null
  
)

export default component.exports